export default __webpack_public_path__ + "static/media/MQ.95747314.svg";